export default __webpack_public_path__ + "static/media/lose@3x.d6ff1bb4.png";